<template>
  <el-container direction = "vertical">
    <top-nav class="hide-when-mobile"></top-nav>
    <mobile-top class="hide-when-pc"></mobile-top>
    <el-main>
      <slot></slot>
    </el-main>
    <footer-nav class="hide-when-mobile"></footer-nav>
    <mobile-footer class="hide-when-pc"></mobile-footer>
  </el-container>
</template>
  
<script>
import TopNav from "./Top";
import MobileTop from "./MobileTop.vue";
import FooterNav from "./Footer";
import MobileFooter from "./MobileFooter.vue";
export default {
  name: "main-wrapper",
  components: {
    TopNav,
    MobileTop,
    FooterNav,
    MobileFooter
  },
};
</script>

<style lang="scss" scoped>
.el-container {
  min-height: 100%;
}
.el-main {
  display: block;
  padding: 0;
  margin-top: 55px;
  @include pc {
    min-width: 1200px;
  }
  @include mobile {
    min-width: 200px;
    overflow-x: hidden;
  }
}
</style>
  